/**
 * @generated SignedSource<<6969f75d91942f41d2c1ce7f494aa6a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BillingGranularity = "DAY" | "MONTH" | "YEAR" | "%future added value";
export type useBillingStatsRelayQuery$variables = {
  endDate?: any | null | undefined;
  granularity: BillingGranularity;
  startDate?: any | null | undefined;
  systemId: string;
};
export type useBillingStatsRelayQuery$data = {
  readonly billingStats: {
    readonly averageChargeAmount: number | null | undefined;
    readonly averageRefundAmount: number | null | undefined;
    readonly chargeDistribution: ReadonlyArray<{
      readonly count: number;
      readonly label: string;
      readonly maxCents: number;
      readonly minCents: number;
    }> | null | undefined;
    readonly chargesByPeriod: ReadonlyArray<{
      readonly count: number;
      readonly period: string;
      readonly totalAmount: number;
    }> | null | undefined;
    readonly id: string;
    readonly refundsByPeriod: ReadonlyArray<{
      readonly count: number;
      readonly period: string;
      readonly totalAmount: number;
    }> | null | undefined;
    readonly totalChargeAmount: number | null | undefined;
    readonly totalChargeCount: number | null | undefined;
    readonly totalRefundAmount: number | null | undefined;
    readonly totalRefundCount: number | null | undefined;
    readonly walletDebitsByPeriod: ReadonlyArray<{
      readonly count: number;
      readonly period: string;
      readonly totalAmount: number;
    }> | null | undefined;
  } | null | undefined;
};
export type useBillingStatsRelayQuery = {
  response: useBillingStatsRelayQuery$data;
  variables: useBillingStatsRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "granularity"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "systemId"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v5 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "period",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalAmount",
    "storageKey": null
  }
],
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "endDate",
        "variableName": "endDate"
      },
      {
        "kind": "Variable",
        "name": "granularity",
        "variableName": "granularity"
      },
      {
        "kind": "Variable",
        "name": "startDate",
        "variableName": "startDate"
      },
      {
        "kind": "Variable",
        "name": "systemId",
        "variableName": "systemId"
      }
    ],
    "concreteType": "BillingStats",
    "kind": "LinkedField",
    "name": "billingStats",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "averageChargeAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "averageRefundAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalChargeAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalChargeCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalRefundAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalRefundCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BillingPeriodStat",
        "kind": "LinkedField",
        "name": "chargesByPeriod",
        "plural": true,
        "selections": (v5/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BillingPeriodStat",
        "kind": "LinkedField",
        "name": "walletDebitsByPeriod",
        "plural": true,
        "selections": (v5/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BillingPeriodStat",
        "kind": "LinkedField",
        "name": "refundsByPeriod",
        "plural": true,
        "selections": (v5/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BillingBucket",
        "kind": "LinkedField",
        "name": "chargeDistribution",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxCents",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minCents",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useBillingStatsRelayQuery",
    "selections": (v6/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useBillingStatsRelayQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "ad3e241d41e42400704ed626ee054d71",
    "id": null,
    "metadata": {},
    "name": "useBillingStatsRelayQuery",
    "operationKind": "query",
    "text": "query useBillingStatsRelayQuery(\n  $systemId: ID!\n  $granularity: BillingGranularity!\n  $startDate: DateTime\n  $endDate: DateTime\n) {\n  billingStats(systemId: $systemId, granularity: $granularity, startDate: $startDate, endDate: $endDate) {\n    id\n    averageChargeAmount\n    averageRefundAmount\n    totalChargeAmount\n    totalChargeCount\n    totalRefundAmount\n    totalRefundCount\n    chargesByPeriod {\n      count\n      period\n      totalAmount\n    }\n    walletDebitsByPeriod {\n      count\n      period\n      totalAmount\n    }\n    refundsByPeriod {\n      count\n      period\n      totalAmount\n    }\n    chargeDistribution {\n      count\n      label\n      maxCents\n      minCents\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d02636fd502008b87f2eccf2b6e2feda";

export default node;
